import { useState, useCallback } from "react";

const etapas = ['Temporada Regular', 'Super Liga', 'Liguilla', 'Reclasificatorio', 'Playoffs', 'Play-in', 'Cuartos de final', 'Semifinal', 'Final'];
const localias = ['Local', 'Visitante'];
const resultados = ['Ganado', 'Perdido'];
const alargues = ['Si', 'No'];

const initialFilters = {
    torneo: '',
    etapa: '',
    cancha: '',
    adversario: '',
    localia: '',
    resultado: '',
    alargue: '',
};

function useBuscarPartidoFilters() {
    const [filters, setFilters] = useState(initialFilters);

    const setFilter = useCallback((key, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [key]: value,
        }));
    }, []);

    const resetFilters = () => {
        setFilters(initialFilters);
    };

    const setAllFilters = useCallback((nextFilters) => {
        setFilters({
            ...initialFilters,
            ...nextFilters,
        });
    }, []);

    return {
        filters,
        setFilter,
        setAllFilters,
        resetFilters,
        options: {
            etapas,
            localias,
            resultados,
            alargues,
        },
    };
}

export default useBuscarPartidoFilters;
